import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }

import { computed, watch, ref, PropType } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import CurrencyInput from "@/components/ui/inputs/currency-input.vue";
import SingleSelect from "@/components/ui/dropdowns/single-select.vue";
import { TenanciesValidation } from "acquaint-api/validation/TenanciesValidation";
import { IdNamePair } from "@/types/generic/IdNamePair";
import FieldValidationFreeTextbox from "@/components/ui/inputs/field-validation-free-textbox.vue";
import { TenantPaymentItem } from "@/types/accounts/TenantPaymentItem";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { useContactHelper } from "@/utils/contacts/useContactHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'edit-tenant-payment-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The payment item in the grid that is to be edited.
   * @type {object as TenantPaymentItem}
   * @required
   */
  tenantPayment: {
    type: Object as PropType<TenantPaymentItem>,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Triggered when the data is saved so the grid in the parent component can be refreshed.
   */
  "paymentUpdated",
],
  setup(__props, { emit }) {

const props = __props;





const fetchedLinkedContacts = ref<IdNamePair[]>([]);
const editableTenantPayment = ref<TenantPaymentItem>();
const receivedFromKey = ref(0);
const useContactsHelper = useContactHelper();

const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const onCancelClick = () => (showModal.value = false);

const onSaveClick = () => {
  emit("paymentUpdated", editableTenantPayment.value);
  showModal.value = false;
};

watch(
  () => showModal.value,
  async () => {
    if (!showModal.value) {
      return;
    }
    editableTenantPayment.value = JSON.parse(
      JSON.stringify(props.tenantPayment),
    );
    fetchedLinkedContacts.value = await useContactsHelper.fetchLinkedContacts(
      props.tenantPayment.contactId,
    );
  },
);

const receivedFromOptions = computed(() => {
  let defaultList = [
    {
      id: props.tenantPayment.contactId,
      description: props.tenantPayment.contact,
    },
  ];

  if (fetchedLinkedContacts.value.length > 0) {
    defaultList = [
      ...defaultList,
      ...fetchedLinkedContacts.value.map((contact) => {
        return {
          id: contact.id,
          description: contact.name,
        };
      }),
    ];
  }
  return defaultList;
});

watch(
  () => receivedFromOptions.value,
  () => {
    receivedFromKey.value++;
  },
);

const disabledReceivedFromField = computed(() => {
  return fetchedLinkedContacts.value.length === 0;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showModal).value = $event)),
    title: "Process Tenant Payments",
    width: _unref(ModalWidth).XSmall
  }, {
    content: _withCtx(() => [
      (editableTenantPayment.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(CurrencyInput, {
              label: "Adjust Received Amount",
              modelValue: editableTenantPayment.value.received,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editableTenantPayment.value.received) = $event)),
              "field-validation": _unref(TenanciesValidation).Amount
            }, null, 8, ["modelValue", "field-validation"]),
            (_openBlock(), _createBlock(SingleSelect, {
              key: receivedFromKey.value,
              label: "Received From",
              modelValue: editableTenantPayment.value.contactId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editableTenantPayment.value.contactId) = $event)),
              "data-source": receivedFromOptions.value,
              "read-only": disabledReceivedFromField.value
            }, null, 8, ["modelValue", "data-source", "read-only"])),
            _createVNode(FieldValidationFreeTextbox, {
              label: "Reference",
              modelValue: editableTenantPayment.value.referenceChequeNo,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editableTenantPayment.value.referenceChequeNo) = $event))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Save',
          onClick: () => {
            onSaveClick();
          },
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})